import { useEffect, useRef, useState } from "react";

export const Reveal = ({ children, delay = 0, className = "" }) => {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const obs = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    obs.disconnect();
                }
            },
            { threshold: 0.12 }
        );
        obs.observe(el);
        return () => obs.disconnect();
    }, []);

    return (
        <div
            ref={ref}
            style={{ transitionDelay: `${delay}ms` }}
            className={`reveal ${visible ? "reveal-visible" : ""} ${className}`}
        >
            {children}
        </div>
    );
};

export const Eyebrow = ({ children, dark = false }) => (
    <p
        className={`text-xs sm:text-sm tracking-[0.25em] uppercase font-semibold ${
            dark ? "text-[#C5A059]" : "text-[#1E3A8A]"
        }`}
    >
        {children}
    </p>
);
